<template>
    <div id="schedule-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                icon="file-pdf-o"
                :action="exportProducts"
                :label="trans('pages.schedule.export_finished_products')"
            />
        </actions-menu>

        <div class="leftcolumn">
            <table
                class="schedule-table"
                :class="{ loading: loading }"
            >
                <thead>
                    <tr class="processed">
                        <th>{{ trans('pages.schedule.week') }}</th>
                        <th>{{ trans('pages.schedule.monday') }}</th>
                        <th>{{ trans('pages.schedule.tuesday') }}</th>
                        <th>{{ trans('pages.schedule.wednesday') }}</th>
                        <th>{{ trans('pages.schedule.thursday') }}</th>
                        <th>{{ trans('pages.schedule.friday') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="weekNr" />
                        <td class="weekDay_1" />
                        <td class="weekDay_2" />
                        <td class="weekDay_3" />
                        <td class="weekDay_4" />
                        <td class="weekDay_5" />
                    </tr>
                    <tr>
                        <td class="weekNr" />
                        <td class="weekDay_1" />
                        <td class="weekDay_2" />
                        <td class="weekDay_3" />
                        <td class="weekDay_4" />
                        <td class="weekDay_5" />
                    </tr>
                    <tr>
                        <td class="weekNr" />
                        <td class="weekDay_1" />
                        <td class="weekDay_2" />
                        <td class="weekDay_3" />
                        <td class="weekDay_4" />
                        <td class="weekDay_5" />
                    </tr>
                    <tr>
                        <td class="weekNr" />
                        <td class="weekDay_1" />
                        <td class="weekDay_2" />
                        <td class="weekDay_3" />
                        <td class="weekDay_4" />
                        <td class="weekDay_5" />
                    </tr>
                    <tr>
                        <td class="weekNr" />
                        <td class="weekDay_1" />
                        <td class="weekDay_2" />
                        <td class="weekDay_3" />
                        <td class="weekDay_4" />
                        <td class="weekDay_5" />
                    </tr>
                    <tr>
                        <td class="weekNr" />
                        <td class="weekDay_1" />
                        <td class="weekDay_2" />
                        <td class="weekDay_3" />
                        <td class="weekDay_4" />
                        <td class="weekDay_5" />
                    </tr>
                </tbody>
            </table>

            <div id="schedule-controls">
                <ui5-button
                    :disabled="loading"
                    @click="shiftDateForSchedule(-1)"
                >
                    {{ trans('pages.schedule.previous') }}
                </ui5-button>
                <div>
                    {{ trans('pages.schedule.schedule_for') }}
                    {{ dateForSchedule }}
                    <spinner v-if="loading" />
                </div>
                <ui5-button
                    :disabled="loading"
                    @click="shiftDateForSchedule(+1)"
                >
                    {{ trans('pages.schedule.next') }}
                </ui5-button>
            </div>
        </div>
    </div>
</template>
<script>
import settingsApi from './../api/settings';
import employeeApi from './../api/employee';
import spinner from './../components/loader/Spinner';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import { months, getDaysInMonth } from '../shared/schedule';
import localization from '../mixins/localization';
import { getWeek } from '../helpers/DateHelper';

export default {
    components: {
        ActionsMenuItem,
        spinner,
        ActionsMenu,
    },
    mixins: [localization],
    data() {
        return {
            loading: false,
            yearForSchedule: '',
            monthForSchedule: '',
            dateForSchedule: '',
            capacityColors: null,
            productionTimes: null,
            workTimeAvailable: null,
            timeDeviation: null,
        };
    },
    methods: {
        shiftDateForSchedule(direction) {
            const oldYear = this.yearForSchedule;
            const oldMonth = this.monthForSchedule;
            const newDate = new Date(
                oldYear,
                oldMonth + parseInt(direction),
                1
            );
            this.drawSchedule(newDate.getMonth(), newDate.getFullYear());
        },
        drawSchedule(month, year) {
            const self = this;
            self.loading = true;

            // Fill in basic date info
            this.$store.commit(
                'general/setPageTitle',
                this.trans('pages.schedule.page_title', {
                    month: months[month],
                    year: year,
                }),
                { root: true }
            );
            self.dateForSchedule = months[month] + ' ' + year;
            self.monthForSchedule = month;
            self.yearForSchedule = year;

            // Get all the days in this month
            const allDays = getDaysInMonth(month, year);
            const firstDay = allDays[0];
            const lastDay = allDays[allDays.length - 1];

            employeeApi
                .fetchAllProductionTimesForRange(
                    firstDay.getTime() / 1000,
                    lastDay.getTime() / 1000
                )
                .then((response) => {
                    const scheduleTable =
                        window.document.getElementsByClassName(
                            'schedule-table'
                        )[0];

                    // Clean up table
                    Array.from(
                        scheduleTable.querySelectorAll('td, tr')
                    ).forEach((element) => {
                        element.classList.remove('processed');
                        element.classList.remove('currentWeek');
                        element.removeAttribute('style');

                        if (element.tagName == 'td') {
                            element.querySelector('.date').innerHTML = '';
                            element.querySelector('.time').innerHTML = '';
                            if (element.classList.contains('weekNr')) {
                                element.innerHtml = '';
                            }
                        }
                    });

                    self.productionTimes = response.data.data.productionTimes; // in mins
                    self.workTimeAvailable =
                        response.data.data.workTimeAvailable;
                    self.timeDeviation = parseInt(
                        response.data.data.capacityDeviation
                    ); // in mins

                    allDays.forEach((date, index) => {
                        let day = date.getDay();
                        if (day == 0) {
                            day = 7;
                        }
                        const dayCell = scheduleTable.querySelector(
                            '.weekDay_' + day + ':not(.processed)'
                        );
                        if (dayCell) {
                            const weekNrCell =
                                dayCell.parentElement.querySelector('.weekNr');

                            // Calculate and add week nr (ISO 8601)
                            const weekNr = getWeek(date, 1);
                            if (
                                weekNrCell &&
                                (!weekNrCell.innerHTML ||
                                    weekNrCell.innerHTML.length == 0)
                            ) {
                                weekNrCell.innerHTML = weekNr;
                            }

                            // Mark current week
                            const currentDate = new Date();
                            const currentWeekNr = getWeek(currentDate, 1);
                            if (weekNrCell && weekNr == currentWeekNr) {
                                dayCell.classList.add('currentWeek');
                                weekNrCell.classList.add('currentWeek');
                            }

                            // Do we have a production time for this date?
                            const productionTime =
                                typeof self.productionTimes[date.getDate()] !=
                                'undefined'
                                    ? self.productionTimes[date.getDate()]
                                    : 0;

                            if (productionTime != 0) {
                                const timeAvailable =
                                    self.workTimeAvailable[date.getDate()];
                                if (
                                    timeAvailable >=
                                        productionTime - self.timeDeviation &&
                                    timeAvailable <=
                                        productionTime + self.timeDeviation
                                ) {
                                    dayCell.style.backgroundColor =
                                        self.capacityColors.scheduleCapacityBalanceColor;
                                } else if (
                                    timeAvailable >
                                    productionTime + self.timeDeviation
                                ) {
                                    dayCell.style.backgroundColor =
                                        self.capacityColors.scheduleCapacitySurplusColor;
                                } else {
                                    dayCell.style.backgroundColor =
                                        self.capacityColors.scheduleCapacityShortageColor;
                                }
                            }

                            dayCell.innerHTML =
                                '<div class="date">' +
                                date.getDate() +
                                '</div>';
                            dayCell.classList.add('processed');
                            dayCell.parentElement.classList.add('processed');
                        }

                        if (index == 0) {
                            Array.from(
                                scheduleTable.querySelectorAll(
                                    'tbody tr:first-child td'
                                )
                            ).forEach((element, index) => {
                                if (index < day) {
                                    element.classList.add('processed');
                                }
                            });
                        }
                    });

                    self.loading = false;
                });
        },
        exportProducts() {
            window.open(
                Config.url + '/export/exportFinishedProducts/',
                '_blank'
            );
        },
    },
    mounted() {
        this.loading = true;
        settingsApi
            .fetchSettings([
                'scheduleCapacityBalanceColor',
                'scheduleCapacitySurplusColor',
                'scheduleCapacityShortageColor',
            ])
            .then((response) => {
                this.capacityColors = response.data.data;

                const currentDate = new Date();
                this.drawSchedule(
                    currentDate.getMonth(),
                    currentDate.getFullYear()
                );
            });
    },
};
</script>
